export default process.env.REACT_APP_GOOGLE_OAUTH_CLIENT_ID;
